import React, { useEffect, useState } from "react";
import { Card, Button, Row, Col, Modal, Form } from "react-bootstrap";
import { rewardService } from "../services";

function Booking() {
  const [rewards, setRewards] = useState([]);

  useEffect(() => {
    getBookingsList();
  }, []);

  // Fetch Rewards List
  const getBookingsList = async () => {
    try {
      const res = await rewardService.getBookingsList();
      if (res && res.data) {
        setRewards(res.data);
      }
    } catch (error) {
      console.log("Error fetching rewards list");
    }
  };

  // Function for Date And Time
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString(); // e.g., 4/16/2025
    const formattedTime = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }); // e.g., 01:45 AM
    return { formattedDate, formattedTime };
  };

  return (
    <div className="tab-content-container">
      <Card className="reward-card p-5">
        <h5>Bookings</h5>
        <p className="section-subtitle">
          Manage your upcoming and past bookings in app.
        </p>

        {rewards.upcomingVisits && rewards.upcomingVisits.length > 0 ? (
          rewards.upcomingVisits.map((reward, index) => {
            const { formattedDate, formattedTime } = formatDateTime(
              reward.bookingDate
            );
            return (
              <Card key={index} className="reward-card">
                <Row className="no-guttersb responsive-mb">
                  <Col md={5} className="position-relative">
                    <Card.Img
                      src={reward.locationImage}
                      alt="Reward"
                      className="reward-image"
                    />
                  </Col>
                  <Col md={7} className="position-relative23">
                    <Card.Body>
                      <Card.Title className="reward-title book-one">
                        {reward.locationName}
                      </Card.Title>
                      <Card.Title className="reward-title book-one1">
                        Date: {formattedDate}
                      </Card.Title>
                      <Card.Title className="reward-title book-one1">
                        Time: {formattedTime}
                      </Card.Title>
                      <Card.Title className="reward-title book-one1">
                        Cover: {reward.partySize}
                      </Card.Title>
                      <Card.Text
                        className="reward-desc change-ds1 booking5"
                        dangerouslySetInnerHTML={{ __html: reward.description }}
                      ></Card.Text>
                      {/* <Button
                className="me-2 redeem-btn custom-bt-design1"
                style={{
                  color: "#FB4C41",
                  border: "1px solid #FB4C41",
                  borderRadius: "0",
                  backgroundColor: "white",
                }}
                onClick={() => window.open(reward.reservationUrl, "_blank")}
              >
                AMEND
              </Button> */}
                      {/* <Button
                className="gift-btn custom-bt-design1 booking4"
                style={{
                  color: "#FB4C41",
                  border: "1px solid #FB4C41",
                  borderRadius: "0",
                  backgroundColor: "white",
                }}
                onClick={() => window.open(reward.reservationUrl, "_blank")}
              >
                CANCEL
              </Button> */}
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
            );
          })
        ) : (
          <p className="text-center text-muted mt-4">You currently have no upcoming  bookings.</p>
        )}
      </Card>
    </div>
  );
}

export default Booking;
